export const INITIAL_PURCHASE_ORDERS = [
  {
    id: "PO-2026-108",
    poNumber: "PO/2026/08/108",
    supplierId: "SUP-001",
    supplierName: "Gemini Edibles & Fats (Freedom Refined Oils, Hyderabad)",
    status: "Sent",
    orderDate: "2026-08-05",
    expectedDate: "2026-08-11",
    warehouseId: "WH-001",
    warehouseName: "Kattedan Industrial Mega Hub (WH-1)",
    freightCharges: 1800,
    packagingCharges: 500,
    handlingCharges: 400,
    notes: "Direct tank transport to Kattedan Hub. Unloading pallet bays A & B.",
    items: [
      {
        id: "POI-101",
        productId: "PROD-004",
        productName: "Freedom Refined Sunflower Oil 15L Commercial Tin",
        orderedQty: 100,
        receivedQty: 0,
        unitPrice: 1780,
        mrp: 2150,
        total: 178000
      },
      {
        id: "POI-102",
        productId: "PROD-005",
        productName: "Fortune Sunlite Refined Sunflower Oil (1L Pouch)",
        orderedQty: 200,
        receivedQty: 0,
        unitPrice: 112,
        mrp: 145,
        total: 22400
      }
    ],
    totalAmount: 200400,
    landedCost: 203100
  },
  {
    id: "PO-2026-109",
    poNumber: "PO/2026/08/109",
    supplierId: "SUP-003",
    supplierName: "Bowenpally APMC Grains & Sona Masoori Mandi",
    status: "Partially Received",
    orderDate: "2026-08-06",
    expectedDate: "2026-08-12",
    warehouseId: "WH-001",
    warehouseName: "Kattedan Industrial Mega Hub (WH-1)",
    freightCharges: 3500,
    packagingCharges: 1200,
    handlingCharges: 800,
    notes: "Lorry arrival scheduled for morning slot. Moisture & grain length check required.",
    items: [
      {
        id: "POI-201",
        productId: "PROD-001",
        productName: "BPT 5204 Premium Sona Masoori Raw Rice (25kg Bag)",
        orderedQty: 150,
        receivedQty: 90,
        unitPrice: 1320,
        mrp: 1650,
        total: 198000
      },
      {
        id: "POI-202",
        productId: "PROD-002",
        productName: "Daawat Rozana Super Basmati Rice (5kg Bag)",
        orderedQty: 100,
        receivedQty: 100,
        unitPrice: 360,
        mrp: 480,
        total: 36000
      },
      {
        id: "POI-203",
        productId: "PROD-007",
        productName: "Desi Toor Dal / Kandipappu Nizamabad Polished (1kg Pkt)",
        orderedQty: 120,
        receivedQty: 0,
        unitPrice: 142,
        mrp: 185,
        total: 17040
      }
    ],
    totalAmount: 251040,
    landedCost: 256540
  },
  {
    id: "PO-2026-110",
    poNumber: "PO/2026/08/110",
    supplierId: "SUP-004",
    supplierName: "Hindustan Unilever Ltd - Uppal Distribution Hub",
    status: "Draft",
    orderDate: "2026-08-07",
    expectedDate: "2026-08-14",
    warehouseId: "WH-001",
    warehouseName: "Kattedan Industrial Mega Hub (WH-1)",
    freightCharges: 1500,
    packagingCharges: 300,
    handlingCharges: 400,
    notes: "Monthly FMCG replenishment stock.",
    items: [
      {
        id: "POI-301",
        productId: "PROD-013",
        productName: "Surf Excel Easy Wash Detergent Powder (5kg Bag)",
        orderedQty: 80,
        receivedQty: 0,
        unitPrice: 490,
        mrp: 650,
        total: 39200
      }
    ],
    totalAmount: 39200,
    landedCost: 41400
  }
];

export const INITIAL_SALES_ORDERS = [
  {
    id: "SO-2026-501",
    orderNumber: "SO/2026/08/501",
    channel: "Wholesale",
    customerId: "CUST-W01",
    customerName: "Paradise Food Court & Caterers (Secunderabad)",
    customerPhone: "+91 98480 12345",
    date: "2026-08-06T09:30:00",
    status: "Completed",
    paymentMethod: "Bank NEFT (Credit 30d)",
    paymentStatus: "Pending",
    items: [
      {
        productId: "PROD-001",
        productName: "BPT 5204 Premium Sona Masoori Raw Rice (25kg Bag)",
        qty: 30,
        costPrice: 1320,
        sellingPrice: 1410,
        mrp: 1650,
        discount: 0,
        total: 42300,
        profit: 2700
      },
      {
        productId: "PROD-004",
        productName: "Freedom Refined Sunflower Oil 15L Commercial Tin",
        qty: 15,
        costPrice: 1780,
        sellingPrice: 1860,
        mrp: 2150,
        discount: 0,
        total: 27900,
        profit: 1200
      }
    ],
    subtotal: 70200,
    taxGst: 3510,
    discountAmount: 0,
    grandTotal: 73710,
    totalProfit: 3900,
    marginPercentage: 5.29
  },
  {
    id: "SO-2026-502",
    orderNumber: "SO/2026/08/502",
    channel: "Wholesale",
    customerId: "CUST-W02",
    customerName: "Bawarchi Biryani & Restaurant (RTC X Roads)",
    customerPhone: "+91 98480 23456",
    date: "2026-08-07T11:15:00",
    status: "Completed",
    paymentMethod: "Cheque / Clearing",
    paymentStatus: "Paid",
    items: [
      {
        productId: "PROD-002",
        productName: "Daawat Rozana Super Basmati Rice (5kg Bag)",
        qty: 40,
        costPrice: 360,
        sellingPrice: 395,
        mrp: 480,
        discount: 0,
        total: 15800,
        profit: 1400
      },
      {
        productId: "PROD-006",
        productName: "Vijaya Telangana Dairy Pure Ghee (1L Tin)",
        qty: 20,
        costPrice: 530,
        sellingPrice: 580,
        mrp: 680,
        discount: 0,
        total: 11600,
        profit: 1000
      },
      {
        productId: "PROD-010",
        productName: "Priya Ginger Garlic Paste Commercial Pack (1kg Pouch)",
        qty: 25,
        costPrice: 115,
        sellingPrice: 128,
        mrp: 160,
        discount: 0,
        total: 3200,
        profit: 325
      }
    ],
    subtotal: 30600,
    taxGst: 1530,
    discountAmount: 0,
    grandTotal: 32130,
    totalProfit: 2725,
    marginPercentage: 8.48
  },
  {
    id: "SO-2026-503",
    orderNumber: "POS-2026-8801",
    channel: "Retail",
    customerId: "CUST-R04",
    customerName: "Walk-in Retail Shopper (Counter POS)",
    customerPhone: "+91 98480 00000",
    date: "2026-08-08T14:20:00",
    status: "Completed",
    paymentMethod: "UPI (PhonePe / GPay)",
    paymentStatus: "Paid",
    items: [
      {
        productId: "PROD-005",
        productName: "Fortune Sunlite Refined Sunflower Oil (1L Pouch)",
        qty: 2,
        costPrice: 112,
        sellingPrice: 135,
        mrp: 145,
        discount: 0,
        total: 270,
        profit: 46
      },
      {
        productId: "PROD-003",
        productName: "Aashirvaad Shudh Chakki Superior MP Whole Wheat Atta (10kg)",
        qty: 1,
        costPrice: 390,
        sellingPrice: 460,
        mrp: 495,
        discount: 0,
        total: 460,
        profit: 70
      }
    ],
    subtotal: 730,
    taxGst: 36,
    discountAmount: 0,
    grandTotal: 766,
    totalProfit: 116,
    marginPercentage: 15.14
  }
];

export const initialStockTransfers = [
  {
    id: "TRF-2026-01",
    transferCode: "TRF/WH1-WH3/0801",
    type: "WH → Shop Godown",
    fromLocationId: "WH-001",
    fromLocationName: "Kattedan Industrial Mega Hub (WH-1)",
    toLocationId: "WH-003",
    toLocationName: "Kukatpally Express Retail Godown (WH-3)",
    productCount: 4,
    totalUnits: 80,
    status: "Completed",
    date: "2026-08-04",
    driverName: "Pandurangam (TS-08-UB-4412)",
    responsiblePerson: "Vikas Goud",
    items: [
      { productId: "PROD-001", productName: "BPT 5204 Premium Sona Masoori Raw Rice (25kg)", qty: 25 },
      { productId: "PROD-004", productName: "Freedom Refined Sunflower Oil 15L Commercial Tin", qty: 20 },
      { productId: "PROD-009", productName: "Tata Salt Vacuum Evaporated Iodized (1kg)", qty: 25 },
      { productId: "PROD-010", productName: "Priya Ginger Garlic Paste (1kg Pouch)", qty: 10 }
    ]
  },
  {
    id: "TRF-2026-02",
    transferCode: "TRF/WH1-WH2/0805",
    type: "WH → WH Distribution",
    fromLocationId: "WH-001",
    fromLocationName: "Kattedan Industrial Mega Hub (WH-1)",
    toLocationId: "WH-002",
    toLocationName: "Begum Bazar Central Distribution Depot (WH-2)",
    productCount: 3,
    totalUnits: 120,
    status: "In Transit",
    date: "2026-08-08",
    driverName: "B. Narsimha (TS-07-CP-9011)",
    responsiblePerson: "Venkateshwar Reddy",
    items: [
      { productId: "PROD-006", productName: "Vijaya Telangana Dairy Pure Ghee (1L Tin)", qty: 40 },
      { productId: "PROD-008", productName: "Warangal Hot Teja Red Chilly Powder (500g)", qty: 50 },
      { productId: "PROD-014", productName: "Red Label Strong CTC Tea Powder (1kg)", qty: 30 }
    ]
  }
];

export const initialGRNs = [
  {
    id: "GRN-2026-041",
    grnNumber: "GRN/2026/08/041",
    poId: "PO-2026-109",
    poNumber: "PO/2026/08/109",
    supplierId: "SUP-003",
    supplierName: "Bowenpally APMC Grains & Sona Masoori Mandi",
    warehouseId: "WH-001",
    warehouseName: "Kattedan Industrial Mega Hub (WH-1)",
    inspector: "Vikas Goud (Receiving Inspector)",
    receivedDate: "2026-08-07",
    status: "Completed",
    notes: "90 bags of Sona Masoori Rice received in good condition. 2 bags punctured in transit written off.",
    items: [
      {
        productId: "PROD-001",
        productName: "BPT 5204 Premium Sona Masoori Raw Rice (25kg Bag)",
        orderedQty: 150,
        receivedQty: 90,
        damagedQty: 2,
        rejectedQty: 0,
        batchNo: "BAT-HYD-SONA-2608",
        mfgDate: "2026-07-15",
        expiryDate: "2027-07-15",
        destinationBin: "A1-S1-B1"
      }
    ]
  }
];

export const initialPurchaseOrders = INITIAL_PURCHASE_ORDERS;
export const initialSalesOrders = INITIAL_SALES_ORDERS;
